import {
  deleteRoomFromPlanner,
  highlightDeviceNoZoom,
  highlightPoint,
  highlightRoom,
  selectRoom,
  setMode,
} from 'src/components/Planner/planner/planner';
import { PlannerGlobals } from 'src/components/Planner/planner/planner-globals';
import { getRoomById, uDev } from 'src/components/Planner/planner/uDev';
import { deepCopy } from 'src/components/Planner/controller';
import { DeleteRoomAction } from 'src/components/Planner/planner/history/room-actions';
import { GetProductsOfRoomsByFloorsProduct, GetProductsOfRoomsByFloorsRoom } from 'src/model/api/v2/data-contracts';
import { UNASSIGNED_ROOMTYPE_NAME } from 'src/utils/constants';

export function isPlannerInRoomEditMode(): boolean {
  return PlannerGlobals.mode === 'selectRoom' || PlannerGlobals.mode === 'modifyOuterW';
}

export function isPredefinedRoom(roomId: number): boolean {
  return roomId === uDev.OUTDOORS_ROOM_ID || roomId === uDev.UNASSIGNED_ROOM_ID;
}

export function isUnassignedRoom(room: GetProductsOfRoomsByFloorsRoom): boolean {
  return room.room_type === UNASSIGNED_ROOMTYPE_NAME;
}

export function isOutdoorRoom(room: GetProductsOfRoomsByFloorsRoom): boolean {
  return room.room_id === uDev.OUTDOORS_ROOM_ID;
}

export function deleteRoomFromPlannerWithHistory(roomId: number): void {
  const room = getRoomById(roomId);
  if (!room) {
    console.debug('room with id', roomId, 'not found');
    return;
  }
  const origiRoom = deepCopy(room);
  const wssd = PlannerGlobals.wallSegmentation.getSaveData();

  const result = deleteRoomFromPlanner(roomId);

  const action = new DeleteRoomAction(origiRoom, result.deletedRoomD3Devs,
      result.deletedWallModConns, result.deletedGroups, result.removedMeasurements,
      wssd, result.removedSerConns);
  PlannerGlobals.plannerHistoryManager.addHistoryEntry(action);
  setMode.basic();
  PlannerGlobals.wallSegmentation.recalcPreserveSave(wssd);
}

export function focusRoomForEditing(roomId: number): void {
  setMode.prepareSelect();
  highlightRoom(roomId);
  selectRoom(roomId);
}

export function highlightRoomOnPlanner(roomId: number): void {
  highlightRoom(roomId);
}

export function focusProductOnPlanner(product: GetProductsOfRoomsByFloorsProduct): void {
  const dev = PlannerGlobals.devices?.find((d: any) =>
      Number(d.product_id) === product.product_id &&
      Math.abs(Number(d.x) - product.x) < 1 &&
      Math.abs(Number(d.y) - product.y) < 1
  );
  if (dev) {
    highlightDeviceNoZoom(dev.deviceId, null, 'rgb(0, 189, 37)', 'rgba(2, 86, 0, 0.98)');
  }
  highlightPoint(product.x, product.y, 3);
}